// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/styles/fonts/SFProDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/styles/fonts/SFProDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/styles/fonts/SFProDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/styles/fonts/SFProDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SF Pro Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("SF Pro Display Semibold"), local("SFProDisplay-Semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}
:root {
  --appSidebarWidth: 400px;
  xPathesWrapperWidth: 400px;
}

.App_site-form-item-icon__VSl2f {
  color: #00A899;
}

.App_ant-tabs-content__ePn05, .App_ant-tabs-tabpane__lbYXp {
  height: 100% !important;
}

.App_ant-col__wA363.App_ant-form-item-control__kPjT1.App_css-dev-only-do-not-override-14wewjn__u-qYr label {
  display: inline !important;
}

.App_ant-form-item-control-input-content__VuQc- {
  display: flex;
  align-items: center !important;
  gap: 8px;
}

.App_site-tree-search-value__7oK08 {
  background: #d3fd1a;
}

.App_ant-tree__zskwn .App_ant-tree-treenode__NVrZ4 {
  align-items: center !important;
}

textarea {
  overflow-y: scroll !important;
}

textarea::-webkit-scrollbar {
  width: 4px !important;
}

textarea::-webkit-scrollbar-thumb {
  background-color: #04867a !important;
  border-radius: 50px !important;
}

textarea::-webkit-scrollbar-track {
  background: #e2e4e7 !important;
}

.App_ant-tree-switcher__IYzSp.App_ant-tree-switcher_close__cx0Mn,
.App_ant-tree-switcher__IYzSp.App_ant-tree-switcher_open__eo1B3 {
  line-height: 46px !important;
}

div[class*=TableAllProjects] .App_ant-table-wrapper__wuuDp {
  padding: 24px !important;
  background: #fff !important;
}

.App_app-sidebar__W\\+dHb {
  width: 50%;
}

.App_app-sidebar__W\\+dHb .App_app-sidebar-content__ZGxMI {
  width: 100%;
}

#App_CDARedactorWrapper__343aH {
  width: 100%;
  max-width: 100%;
}

.App_ant-tree-treenode__NVrZ4 {
  min-width: 400px !important;
  max-width: 600px !important;
}

.App_fullScreen__GeFqT {
  position: fixed !important;
  width: 100vw !important;
  height: 100vh !important;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  z-index: 9 !important;
  background: #F0F2F5 !important;
}
.App_fullScreen__GeFqT .App_app-container__2xooS {
  min-height: 90vh;
  padding: 1em 1em;
  display: flex;
  flex-direction: row;
  height: 90vh;
}
.App_fullScreen__GeFqT .App_app-sidebar__W\\+dHb {
  flex-grow: 0;
  flex-shrink: 0;
  min-width: 400px;
  max-width: calc(100vw - var(--appSidebarWidth)) !important;
  display: flex;
  flex-direction: row;
  z-index: 2;
}
.App_fullScreen__GeFqT .App_app-frame__a-I04 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 90vh;
  max-height: 90vh;
  width: calc(100vw - var(--xPathesWrapperWidth) - 200px) !important;
  min-width: 400px;
  border-radius: 0 10px 10px 0;
  z-index: 1;
}
.App_fullScreen__GeFqT .App_app-sidebar__W\\+dHb .App_app-sidebar-content__ZGxMI {
  flex: 1 1;
}
.App_fullScreen__GeFqT .App_app-sidebar-resizer__VqPej {
  position: relative;
  height: 84vh;
  width: 3px;
  top: 4vh;
  border-radius: 10px;
  background: rgba(193, 195, 197, 0.7058823529);
  flex-grow: 0;
  flex-shrink: 0;
  justify-self: flex-end;
  cursor: col-resize;
  resize: horizontal;
}
.App_fullScreen__GeFqT .App_ant-tree-treenode__NVrZ4.App_ant-tree-treenode-switcher-open__0NtUm.App_ant-tree-treenode-draggable__Vjx1b {
  width: 100% !important;
  max-width: 100% !important;
  position: relative;
}
.App_fullScreen__GeFqT .App_app-sidebar__W\\+dHb .App_app-sidebar-resizer__VqPej:hover {
  width: 4px;
  background: grey;
}
.App_fullScreen__GeFqT #App_CDAInitHeight__XztyM {
  width: 100vw !important;
  height: 92vh !important;
  transition: width 0.5s !important;
}
.App_fullScreen__GeFqT #App_CDA_content__DlbUD {
  width: 100% !important;
  height: 92vh !important;
  padding: 0 !important;
}
.App_fullScreen__GeFqT .App_footer__wh\\+Vj > div {
  height: 8vh !important;
}
.App_fullScreen__GeFqT [class^=VisualizationXPathes] {
  height: 69vh !important;
}
.App_fullScreen__GeFqT #App_xPathesWrapper__gM\\+IO,
.App_fullScreen__GeFqT #App_CDARedactorWrapper__343aH {
  max-width: 100%;
}
.App_fullScreen__GeFqT #App_CDARedactor__fJ2ey {
  height: 100vh !important;
  transition: height 1s !important;
}
.App_fullScreen__GeFqT #App_StructureXPathes__uqPns {
  height: auto !important;
  transition: height 1s !important;
}
.App_fullScreen__GeFqT #App_CDARedactor_tabContent__0QlUZ,
.App_fullScreen__GeFqT #App_StructureXPathes_content__roAhc {
  height: 76vh !important;
  transition: height 1s !important;
}

.App_ant-tree-treenode__NVrZ4 {
  width: 100% !important;
}

.App_ant-tree-node-content-wrapper__Y4BZl {
  width: 100% !important;
}

.App_ant-tree-checkbox__-0njm {
  align-self: center !important;
  margin-top: 0 !important;
}

.App_ant-tree-checkbox__-0njm + span {
  padding: 0 !important;
}

.App_ant-tree-treenode__NVrZ4.App_ant-tree-treenode-switcher-close__Hh5Nk.App_ant-tree-treenode-draggable__Vjx1b {
  width: 100% !important;
  max-width: 100% !important;
}

.App_ant-tree-treenode__NVrZ4.App_ant-tree-treenode-switcher-open__0NtUm.App_ant-tree-treenode-draggable__Vjx1b {
  width: 100% !important;
  max-width: 100% !important;
}

.App_ant-tabs-nav__3miIR {
  height: 4vh !important;
}

.App_ant-tabs-tab-remove__UJW91 {
  padding: 0 !important;
}

.App_App__fs6T2 {
  height: 100vh;
}

.App_Error__vo2tU {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.App_Error__vo2tU .App_message__T1ubj {
  width: 500px;
  height: 130px;
  background: white;
  text-align: center;
  z-index: 999;
  border: 1px solid #00A899;
  line-height: 9em;
}`, "",{"version":3,"sources":["webpack://./src/components/assets/styles/fonts/fonts.css","webpack://./src/components/modules/app/components/App/App.module.scss","webpack://./src/components/assets/styles/base/base.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,4CAAA;EACA,uTAAA;EAKA,gBAAA;EACA,kBAAA;ACHJ;ACJA;EACE,wBAAA;EACA,0BAAA;ADMF;;ACWA;EACE,cAfW;ADOb;;ACWA;EACE,uBAAA;ADRF;;ACYE;EACE,0BAAA;ADTJ;;ACaA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;ADVF;;ACcA;EACE,mBAAA;ADXF;;ACcA;EACE,8BAAA;ADXF;;ACcA;EACE,6BAAA;ADXF;;ACcA;EACE,qBAAA;ADXF;;ACcA;EACE,oCAAA;EACA,8BAAA;ADXF;;ACcA;EACE,8BAAA;ADXF;;ACcA;;EAEE,4BAAA;ADXF;;ACgBE;EACE,wBAAA;EACA,2BAAA;ADbJ;;ACiBA;EACE,UAAA;ADdF;;ACiBA;EACE,WAAA;ADdF;;ACiBA;EACE,WAAA;EACA,eAAA;ADdF;;ACiBA;EACE,2BAAA;EACA,2BAAA;ADdF;;ACiBA;EACE,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,8BAAA;ADdF;ACgBE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;ADdJ;ACiBE;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,0DAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;ADfJ;ACkBE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,kEAAA;EACA,gBAAA;EACA,4BAAA;EACA,UAAA;ADhBJ;ACmBE;EACE,SAAA;ADjBJ;ACoBE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,6CAAA;EAEA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;ADnBJ;ACqBE;EAEE,sBAAA;EACA,0BAAA;EACA,kBAAA;ADpBJ;ACuBE;EACE,UAAA;EACA,gBAAA;ADrBJ;ACwBE;EACE,uBAAA;EACA,uBAAA;EACA,iCAAA;ADtBJ;ACwBE;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;ADtBJ;ACyBE;EACE,sBAAA;ADvBJ;ACyBE;EACE,uBAAA;ADvBJ;ACyBE;;EAEE,eAAA;ADvBJ;AC0BE;EACE,wBAAA;EACA,gCAAA;ADxBJ;AC2BE;EACE,uBAAA;EACA,gCAAA;ADzBJ;AC4BE;;EAEE,uBAAA;EACA,gCAAA;AD1BJ;;AC8BA;EACE,sBAAA;AD3BF;;AC8BA;EACE,sBAAA;AD3BF;;AC8BA;EACE,6BAAA;EACA,wBAAA;AD3BF;;AC8BA;EACE,qBAAA;AD3BF;;AC6BA;EACE,sBAAA;EACA,0BAAA;AD1BF;;AC4BA;EACE,sBAAA;EACA,0BAAA;ADzBF;;AC4BA;EACE,sBAAA;ADzBF;;AC4BA;EACE,qBAAA;ADzBF;;AApNA;EACE,aAAA;AAuNF;;AAnNA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAsNF;AArNE;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;AAuNJ","sourcesContent":["@font-face {\n    font-family: 'SF Pro Display';\n    src: url('SFProDisplay-Semibold.eot');\n    src: local('SF Pro Display Semibold'), local('SFProDisplay-Semibold'),\n        url('SFProDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n        url('SFProDisplay-Semibold.woff2') format('woff2'),\n        url('SFProDisplay-Semibold.woff') format('woff'),\n        url('SFProDisplay-Semibold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n}\n","@import \"../../../../assets/styles/base/base\";\n.App {\n  height: 100vh;\n  //overflow: hidden;\n}\n\n.Error {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .message {\n    width: 500px;\n    height: 130px;\n    background: white;\n    text-align: center;\n    z-index: 999;\n    border: 1px solid $primeColor;\n    line-height: 9em;\n  }\n}","@import \"../mixins/mixins\";\n\n:root {\n  --appSidebarWidth: 400px;\n  xPathesWrapperWidth: 400px;\n}\n\n$primeColor: #00A899;\n$backgroundColor: #04867a;\n\nbody {\n  //font-family: Roboto;\n  //font-size: 14px;\n  //font-style: normal;\n  //font-weight: 500;\n  //line-height: 22px;\n  //font-family: \"SF Pro Display\", serif;\n  //font-weight: 500;\n  //min-height: 100%;\n}\n\n.site-form-item-icon {\n  color: $primeColor;\n}\n\n.ant-tabs-content, .ant-tabs-tabpane {\n  height: 100% !important;\n}\n\n.ant-col.ant-form-item-control.css-dev-only-do-not-override-14wewjn {\n  label {\n    display: inline !important;\n  }\n}\n\n.ant-form-item-control-input-content {\n  display: flex;\n  align-items: center !important;\n  gap: 8px;\n}\n\n\n.site-tree-search-value {\n  background: #d3fd1a;\n}\n\n.ant-tree .ant-tree-treenode {\n  align-items: center !important;\n}\n\ntextarea {\n  overflow-y: scroll !important;\n}\n\ntextarea::-webkit-scrollbar {\n  width: 4px !important;\n}\n\ntextarea::-webkit-scrollbar-thumb {\n  background-color: $backgroundColor !important;\n  border-radius: 50px !important;\n}\n\ntextarea::-webkit-scrollbar-track {\n  background: #e2e4e7 !important;\n}\n\n.ant-tree-switcher.ant-tree-switcher_close,\n.ant-tree-switcher.ant-tree-switcher_open {\n  line-height: 46px !important;\n}\n\ndiv[class*=\"TableAllProjects\"] {\n  //.ant-table-wrapper.css-dev-only-do-not-override-1x83488 {\n  .ant-table-wrapper {\n    padding: 24px !important;\n    background: #fff !important;\n  }\n}\n\n.app-sidebar {\n  width: 50%;\n}\n\n.app-sidebar .app-sidebar-content {\n  width: 100%;\n}\n\n#CDARedactorWrapper {\n  width: 100%;\n  max-width: 100%;\n}\n\n.ant-tree-treenode {\n  min-width: 400px !important;\n  max-width: 600px !important;\n}\n\n.fullScreen {\n  position: fixed !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  left: 0 !important;\n  right: 0 !important;\n  top: 0 !important;\n  bottom: 0 !important;\n  z-index: 9 !important;\n  background: #F0F2F5 !important;\n\n  .app-container {\n    min-height: 90vh;\n    padding: 1em 1em;\n    display: flex;\n    flex-direction: row;\n    height: 90vh;\n  }\n\n  .app-sidebar {\n    flex-grow: 0;\n    flex-shrink: 0;\n    min-width: 400px;\n    max-width: calc(100vw - var(--appSidebarWidth))!important;\n    display: flex;\n    flex-direction: row;\n    z-index: 2;\n  }\n\n  .app-frame {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    height: 90vh;\n    max-height: 90vh;\n    width: calc(100vw - var(--xPathesWrapperWidth) - 200px)!important;\n    min-width: 400px;\n    border-radius: 0 10px 10px 0;\n    z-index: 1;\n  }\n\n  .app-sidebar .app-sidebar-content {\n    flex: 1;\n  }\n\n  .app-sidebar-resizer {\n    position: relative;\n    height: 84vh;\n    width: 3px;\n    top: 4vh;\n    border-radius: 10px;\n    background: #c1c3c5b4;\n\n    flex-grow: 0;\n    flex-shrink: 0;\n    justify-self: flex-end;\n    cursor: col-resize;\n    resize: horizontal;\n  }\n  .ant-tree-treenode.ant-tree-treenode-switcher-open.ant-tree-treenode-draggable{\n    //width: calc(100vw - var(--xPathesWrapperWidth))!important;\n    width: 100%!important;\n    max-width: 100%!important;\n    position: relative;\n  }\n\n  .app-sidebar .app-sidebar-resizer:hover {\n    width: 4px;\n    background: grey;\n  }\n\n  #CDAInitHeight {\n    width: 100vw !important;\n    height: 92vh !important;\n    transition: width 0.5s !important;\n  }\n  #CDA_content {\n    width: 100% !important;\n    height: 92vh !important;\n    padding: 0!important;\n  }\n\n  .footer > div {\n    height: 8vh!important;\n  }\n  [class^=VisualizationXPathes] {\n    height: 69vh!important;\n  }\n  #xPathesWrapper,\n  #CDARedactorWrapper {\n    max-width: 100%;\n  }\n\n  #CDARedactor {\n    height: 100vh !important;\n    transition: height 1s !important;\n  }\n\n  #StructureXPathes {\n    height: auto !important;\n    transition: height 1s !important;\n  }\n\n  #CDARedactor_tabContent,\n  #StructureXPathes_content {\n    height: 76vh !important;\n    transition: height 1s !important;\n  }\n}\n\n.ant-tree-treenode {\n  width: 100% !important;\n}\n\n.ant-tree-node-content-wrapper {\n  width: 100% !important;\n}\n\n.ant-tree-checkbox {\n  align-self: center !important;\n  margin-top: 0 !important;\n}\n\n.ant-tree-checkbox + span {\n  padding: 0 !important;\n}\n.ant-tree-treenode.ant-tree-treenode-switcher-close.ant-tree-treenode-draggable {\n  width: 100%!important;\n  max-width: 100%!important;\n}\n.ant-tree-treenode.ant-tree-treenode-switcher-open.ant-tree-treenode-draggable {\n  width: 100%!important;\n  max-width: 100%!important;\n}\n\n.ant-tabs-nav {\n  height: 4vh!important;\n}\n\n.ant-tabs-tab-remove {\n  padding: 0!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"site-form-item-icon": `App_site-form-item-icon__VSl2f`,
	"ant-tabs-content": `App_ant-tabs-content__ePn05`,
	"ant-tabs-tabpane": `App_ant-tabs-tabpane__lbYXp`,
	"ant-col": `App_ant-col__wA363`,
	"ant-form-item-control": `App_ant-form-item-control__kPjT1`,
	"css-dev-only-do-not-override-14wewjn": `App_css-dev-only-do-not-override-14wewjn__u-qYr`,
	"ant-form-item-control-input-content": `App_ant-form-item-control-input-content__VuQc-`,
	"site-tree-search-value": `App_site-tree-search-value__7oK08`,
	"ant-tree": `App_ant-tree__zskwn`,
	"ant-tree-treenode": `App_ant-tree-treenode__NVrZ4`,
	"ant-tree-switcher": `App_ant-tree-switcher__IYzSp`,
	"ant-tree-switcher_close": `App_ant-tree-switcher_close__cx0Mn`,
	"ant-tree-switcher_open": `App_ant-tree-switcher_open__eo1B3`,
	"ant-table-wrapper": `App_ant-table-wrapper__wuuDp`,
	"app-sidebar": `App_app-sidebar__W+dHb`,
	"app-sidebar-content": `App_app-sidebar-content__ZGxMI`,
	"CDARedactorWrapper": `App_CDARedactorWrapper__343aH`,
	"fullScreen": `App_fullScreen__GeFqT`,
	"app-container": `App_app-container__2xooS`,
	"app-frame": `App_app-frame__a-I04`,
	"app-sidebar-resizer": `App_app-sidebar-resizer__VqPej`,
	"ant-tree-treenode-switcher-open": `App_ant-tree-treenode-switcher-open__0NtUm`,
	"ant-tree-treenode-draggable": `App_ant-tree-treenode-draggable__Vjx1b`,
	"CDAInitHeight": `App_CDAInitHeight__XztyM`,
	"CDA_content": `App_CDA_content__DlbUD`,
	"footer": `App_footer__wh+Vj`,
	"xPathesWrapper": `App_xPathesWrapper__gM+IO`,
	"CDARedactor": `App_CDARedactor__fJ2ey`,
	"StructureXPathes": `App_StructureXPathes__uqPns`,
	"CDARedactor_tabContent": `App_CDARedactor_tabContent__0QlUZ`,
	"StructureXPathes_content": `App_StructureXPathes_content__roAhc`,
	"ant-tree-node-content-wrapper": `App_ant-tree-node-content-wrapper__Y4BZl`,
	"ant-tree-checkbox": `App_ant-tree-checkbox__-0njm`,
	"ant-tree-treenode-switcher-close": `App_ant-tree-treenode-switcher-close__Hh5Nk`,
	"ant-tabs-nav": `App_ant-tabs-nav__3miIR`,
	"ant-tabs-tab-remove": `App_ant-tabs-tab-remove__UJW91`,
	"App": `App_App__fs6T2`,
	"Error": `App_Error__vo2tU`,
	"message": `App_message__T1ubj`
};
export default ___CSS_LOADER_EXPORT___;
